import { h, Host } from "@stencil/core";
export class TableSort {
    constructor() {
        this.ascName = undefined;
        this.descName = undefined;
        this.sortedDirection = "";
        this.numerical = false;
    }
    domElement;
    /** when the sort Button is clicked it emits the asc or desc name  */
    sortEvent;
    /** sort ascending */
    async sortAsc() {
        this.sort("asc");
    }
    /** sort descending */
    async sortDesc() {
        this.sort("desc");
    }
    // @ts-expect-error Check for typing
    sort(direction = null) {
        if (direction === null) {
            this.sortedDirection = this.sortedDirection !== "asc" ? "asc" : "desc";
        }
        else {
            this.sortedDirection = direction;
        }
        const name = this.sortedDirection === "asc" ? this.ascName : this.descName;
        this.sortEvent.emit({
            name: name,
            numerical: this.numerical
        });
        // @ts-expect-error Check for typing
        const allSorters = this.domElement.closest("tr").querySelectorAll("ux-table-sort");
        [].forEach.call(allSorters, (element) => {
            if (element.isEqualNode(this.domElement)) {
                return;
            }
            element.sortedDirection = "";
        });
    }
    render() {
        const baseClass = "ux-table-sort";
        return (h(Host, { key: 'b64987cf8ac3576f3f32b95af8940e03a03e6c14', class: baseClass, onClick: () => this.sort() }, h("span", { key: 'ad87716ad54074b01abe47fe8f0df0e13719c04a', class: `${baseClass}__text` }, h("slot", { key: 'fb45983f62afdfa0ca10d68ce094105c99dd42c5' })), "\u00A0", h("ux-icon", { key: '5ace7f2900778b621067614dd22429f1d4496331', class: `${baseClass}__icon`, name: "sort", weight: "bold" })));
    }
    static get is() { return "ux-table-sort"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-sort.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-sort.css"]
        };
    }
    static get properties() {
        return {
            "ascName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is the name to send when it should sort ascending"
                },
                "attribute": "asc-name",
                "reflect": false
            },
            "descName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is the name to send when it should sort descending"
                },
                "attribute": "desc-name",
                "reflect": false
            },
            "sortedDirection": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "\"\" | \"asc\" | \"desc\"",
                    "resolved": "\"\" | \"asc\" | \"desc\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates in which direction the data is already sorted.\nThis has to be empty when it is not sorted yet. Setting this does not trigger the sorting event.\nClicking the button will update this attribute."
                },
                "attribute": "sorted-direction",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "numerical": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, the sorting will be executed on a numerical value"
                },
                "attribute": "numerical",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "sortEvent",
                "name": "uxTableSort",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "when the sort Button is clicked it emits the asc or desc name"
                },
                "complexType": {
                    "original": "{ name: string; numerical: boolean }",
                    "resolved": "{ name: string; numerical: boolean; }",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "sortAsc": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "sort ascending",
                    "tags": []
                }
            },
            "sortDesc": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "sort descending",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "domElement"; }
}
//# sourceMappingURL=table-sort.js.map
